module.exports = __webpack_public_path__ + "img/swiper2.d45b1208.jpg";